<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import AudioFileIssueInspector from '@/components/AudioFileIssueInspector.vue';

const route = useRoute();
const trackCode = computed(() => String(route.params.code ?? '').trim().toUpperCase());
</script>

<template>
  <div v-if="trackCode" class="mx-auto flex w-full max-w-5xl flex-1 flex-col gap-4 p-6 max-md:pb-mobile-area-bar-clearance">
    <div>
      <h1 class="text-lg font-semibold">Audio file issues</h1>
      <p class="text-muted-foreground mt-1 font-mono text-sm">{{ trackCode }}</p>
    </div>
    <AudioFileIssueInspector :track-code="trackCode" />
  </div>
</template>
